import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      viewBox="350 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M366.86 13.0631C364.699 14.2765 362.667 15.6921 360.802 17.31C355.593 21.8694 351.992 27.8812 350.292 34.6835C345.601 32.1832 340.762 29.9403 335.775 27.9915C326.781 24.4616 317.361 21.7959 307.684 20.1045L305.874 19.7735C305.569 19.7276 305.264 19.6862 304.959 19.6449C304.655 19.6035 304.35 19.5621 304.045 19.5162L300.388 19.0198C299.33 18.8442 298.272 18.7518 297.202 18.6583C297.039 18.6441 296.876 18.6299 296.713 18.6153L293.019 18.2844C288.087 18.027 283.101 17.7696 278.132 17.9718C268.177 18.2476 258.186 19.4978 248.36 21.7591C238.516 24.002 228.893 27.3848 219.621 31.6684C201.078 40.2357 184.031 52.6821 169.957 68.1988C181.944 51.0275 197.55 36.0624 215.761 24.6271C224.867 18.9278 234.6 14.0191 244.832 10.2687C255.046 6.48142 265.721 3.72372 276.618 2.01395C282.066 1.09472 287.57 0.653485 293.111 0.249022L297.267 0.0835599C297.61 0.0744443 297.955 0.0630689 298.3 0.0516747C299.347 0.0171079 300.399 -0.0176326 301.441 0.0100212L305.615 0.0467905C305.959 0.0560433 306.307 0.0606393 306.658 0.0652659C307.005 0.069832 307.353 0.074428 307.702 0.0835599L309.789 0.193868C320.945 0.708639 332.119 2.34487 343.089 5.10257C351.179 7.12489 359.121 9.79066 366.86 13.0631Z"
        fill="#FF6002"
      />
      <path
        d="M389.976 20.2341C388.96 20.2341 387.926 20.2892 386.91 20.4179C376.66 21.5578 367.148 28.4704 365.855 41.1558C365.763 42.1118 365.707 43.123 365.707 44.1525C365.707 60.092 377.842 68.0526 389.976 68.0526C402.11 68.0526 414.245 60.092 414.245 44.1525C414.245 28.1946 402.11 20.2341 389.976 20.2341Z"
        fill="#FF6002"
      />
      <path
        d="M357.163 85C338.62 92 318.95 95.2 299.649 94.6C280.33 94 261.436 89.6 244.333 81.9C235.117 77.8 226.436 72.7 218.439 66.8V98.1C224.183 100.5 230.038 102.7 235.985 104.4C256.985 110.7 278.982 112.7 300.259 110.5C321.536 108.4 342.147 102.1 360.525 92.2C378.92 82.4 395.062 69 407.917 53.3C393.086 67.2 375.706 77.9 357.163 85Z"
        fill="#FF6002"
      />
    </svg>
  );
};

export default LogoIcon;
